import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import {
  fetchPendingClosedCircles,
  fetchChangeCircleStatusSubmission,
} from 'modules/circles/actions';
import ClosedCirclesComponent from 'modules/circles/components/ClosedCirclesComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const ClosedCirclesContainer = ({ closedCirclesListApiCallBody }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { closedCirclesList } = useSelector(state => ({
    closedCirclesList: state.circles.closedCirclesList,
  }));

  const dispatch = useDispatch();

  // const companyProfileKey = sessionStorage.getItem('companyProfileKeyAuthCookie');
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [showCopiedTextOverlay, setShowCopiedTextOverlay] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPageFilter, setSelectedPageFilter] = useState(1);
  const [isPreviewFilePopupOpen, setIsPreviewFilePopupOpen] = useState(false);
  const [previewFileData, setPreviewFileData] = useState({});
  const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);
  const [isActionPopupLoading, setIsActionPopupLoading] = useState(false);
  const [actionPopupStatus, setActionPopupStatus] = useState({});
  const [actionPopupTarget, setActionPopupTarget] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // eslint-disable-next-line no-unused-vars
  const submitSearchQuery = reset => {
    // setSelectedPageFilter(1);
    // const body = {
    //   ...ordersApiCallParams,
    // };
    // if (searchQuery) body.searchTerm = searchQuery;
    // if (reset) delete body.searchTerm;
    // setOrdersApiCallParams(body);
    // dispatch(fetchAllOrders(body));
  };

  const reloadClosedCirclesPage = () => {
    const totalResultsCount = closedCirclesList?.details?.totalCount;
    const numberOfPages = (totalResultsCount && Math.ceil((totalResultsCount - 1) / 10)) || 1;

    const data = {
      ...closedCirclesListApiCallBody,
    };

    if (selectedPageFilter > numberOfPages) {
      const previousPage = selectedPageFilter - 1;
      setSelectedPageFilter(previousPage);
      data.Page = previousPage;
    } else data.Page = selectedPageFilter;

    const body = {
      data,
    };

    dispatch(fetchPendingClosedCircles(body));
  };

  const actionPopupConfirmBtnCallback = shouldReloadOrderDetails => {
    setIsActionPopupOpen(false);
    setIsActionPopupLoading(false);
    setActionPopupStatus({});
    setActionPopupTarget('');

    if (shouldReloadOrderDetails) reloadClosedCirclesPage();
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleDoctorsPaginationClick = selectedPageNumber => {
    setSelectedPageFilter(selectedPageNumber);

    const data = {
      ...closedCirclesListApiCallBody,
    };
    data.Page = selectedPageNumber;
    const body = {
      data,
    };

    dispatch(fetchPendingClosedCircles(body));
  };

  const handleTextToCopyToClipboardClick = textToCopy => {
    navigator.clipboard.writeText(textToCopy);
    setShowCopiedTextOverlay(true);

    setTimeout(() => {
      setShowCopiedTextOverlay(false);
    }, 1000);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;
    const searchQueryMinLength = 3;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        submitSearchQuery();
      }, 300);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      submitSearchQuery(true);
  };

  const handlePreviewFileClick = (openPopup, fileType, fileUrl) => {
    if (openPopup) {
      setPreviewFileData({ type: fileType, url: fileUrl });
      setIsPreviewFilePopupOpen(true);
    } else setIsPreviewFilePopupOpen(false);
  };

  const handleActionBtnClick = (circleKey, status) => {
    setIsActionPopupOpen(true);
    setActionPopupStatus(status);
    setActionPopupTarget(circleKey);
  };

  const handleActionPopupConfirmBtnClick = () => {
    setIsActionPopupLoading(true);

    const body = {
      data: {
        circleStatus: 'Active',
      },
      circleKey: actionPopupTarget,
      actionPopupCallbackAction: actionPopupConfirmBtnCallback,
    };

    dispatch(fetchChangeCircleStatusSubmission(body));
  };

  const handleActionPopupDismissBtnClick = () => {
    setIsActionPopupOpen(false);
    setActionPopupStatus({});
    setActionPopupTarget('');
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <ClosedCirclesComponent
      showCopiedTextOverlay={showCopiedTextOverlay}
      searchQuery={searchQuery}
      selectedPageFilter={selectedPageFilter}
      isPreviewFilePopupOpen={isPreviewFilePopupOpen}
      previewFileData={previewFileData}
      isActionPopupOpen={isActionPopupOpen}
      isActionPopupLoading={isActionPopupLoading}
      actionPopupStatus={actionPopupStatus}
      actionPopupTarget={actionPopupTarget}
      handleDoctorsPaginationClick={handleDoctorsPaginationClick}
      handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
      handleSearchBarInputChange={handleSearchBarInputChange}
      handlePreviewFileClick={handlePreviewFileClick}
      handleActionBtnClick={handleActionBtnClick}
      handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
      handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

ClosedCirclesContainer.propTypes = {
  closedCirclesListApiCallBody: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
};

ClosedCirclesContainer.defaultProps = {};

export default ClosedCirclesContainer;
